import {inject, Injectable} from '@angular/core';
import {CmsApiService} from "./cms-api.service";
import {DateInfo} from "./definitions/date-info";
import {MetaField} from "./definitions/meta-field";

@Injectable({
  providedIn: 'root'
})
export class FieldDateInfoService {
  // Injections
  private readonly cms: CmsApiService = inject(CmsApiService);

  private fieldDateInfo: {[id: string]: DateInfo}

  setFieldDateInfo() {
    this.cms.getFieldDateInfo().then(fieldDateInfo => {
      this.fieldDateInfo = fieldDateInfo;
    })
  }

  getFieldDateInfo(metaField: MetaField): DateInfo {
    let res = null;
    if (metaField.date_info) {
      res = metaField.date_info;
    } else if (metaField.date_info_id) {
      if (this.fieldDateInfo) {
        res = this.fieldDateInfo[metaField.date_info_id];
      } else {
        this.setFieldDateInfo();
      }
    }
    return res;
  }

  getAllFieldDateInfo(): {[id: string]: DateInfo} {
    if (!this.fieldDateInfo) {
      this.setFieldDateInfo();
    }
    return this.fieldDateInfo || {};
  }
}
